import { useEffect, useState } from 'react'
import uniqBy from 'lodash/uniqBy'

import { useQueryList, useRequiredParams } from '@percent/partner-dashboard/common/hooks'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'
import { CandidateComment } from '@percent/partner-dashboard/services/grants/grantsService.types'
import { useCandidateDetailsQueryParams } from './useCandidateDetailsQueryParams'

export const DEFAULT_COMMENTS_PAGE_SIZE = 10

export function useCandidateComments() {
  const { id: programId, candidateId } = useRequiredParams()
  const [queryParams, setQueryParams] = useCandidateDetailsQueryParams()
  const [showComments, setShowComments] = useState(queryParams.comments === 'true')
  const [accumulatedComments, setAccumulatedComments] = useState<CandidateComment[]>([])

  const { grantsService } = useServices()

  const [{ data, isLoading, totalResults }, { nextPage, refresh, query }] = useQueryList(
    grantsService.getCandidateComments,
    {
      programId,
      candidateId,
      pageSize: DEFAULT_COMMENTS_PAGE_SIZE,
      direction: 'DESC'
    }
  )

  useEffect(() => {
    if (data) {
      setAccumulatedComments(prev => uniqBy([...prev, ...data], 'id'))
    }
  }, [data])

  const handleCloseComments = () => {
    setQueryParams({ comments: undefined })
  }

  const handleOpenComments = () => {
    setQueryParams({ comments: 'true', tasksView: undefined, formId: undefined })
  }

  useEffect(() => {
    setShowComments(queryParams.comments === 'true')
  }, [queryParams.comments])

  const fetchLatestPage = () => {
    query({ programId, candidateId, pageSize: DEFAULT_COMMENTS_PAGE_SIZE })
  }

  return {
    showComments,
    handleCloseComments,
    handleOpenComments,
    commentsQuery: {
      data: accumulatedComments,
      isLoading,
      totalResults: totalResults ?? 0,
      nextPage: nextPage ?? (() => undefined),
      refresh,
      fetchLatestPage
    }
  }
}
